







import Vue from 'vue'
import VueCookies from 'vue-cookies'

new Vue(VueCookies)

export default
  watch:
    $route: (to, from) ->
      window.isFirstAccess = true
      if from.meta.title
        window.isFirstAccess = false
      if to.fullPath == '/user/append' && from.fullPath != '/user/confirm'
        VueCookies.set('user_append_url', from.fullPath, 0)
      window.scrollTo(0, 0)
      window.beforeUrl = from
      document.title = @$route.meta.title
      document.querySelector('meta[name="description"]').setAttribute('content', @$route.meta.description)
      document.querySelector('meta[name="Keywords"]').setAttribute('content', @$route.meta.keyword)
